<template>
  <ShokurekishoJobHistoryCard
    :basic-data="basicData"
    :current-card-id="currentCardId"
    :lead="careerLead"
    :show-omonajiseki="false"
    variant="career"
  />
</template>

<script setup lang="ts">
import ShokurekishoJobHistoryCard from '@/components/format-edit/shokurekisho/ShokurekishoJobHistoryCard.vue'
import type { BasicData } from '@/utils/format-edit/basicData'

defineProps<{
  currentCardId?: string
  basicData: BasicData
}>()

const careerLead =
  '今までに在籍した会社の概要を入力しましょう。\n職種ごとに、業務の実績や参加プロジェクトの説明も追加できます。'
</script>
